import A from './A/A.jsx';
import Redirect from './Redirect/Redirect';

export {
    A,
    Redirect,
};
export default A;
